import React, { useEffect, useRef, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { baseUrl } from "../../../../Environments/environment";
import { apiClient } from "../../../../api";
import { useProperty } from "../../../../Contexts/PropertyContext/PropertyContext";
import { Switch } from "@headlessui/react";
import { toast } from "react-toastify";

const NewFlowModal = ({ onClose }) => {
  const dropdownRef = useRef(null);
  const searchInputRef = useRef(null);
  const { selectedPropertyId } = useProperty();
  const [flowName, setFlowName] = useState("");
  const [description, setDescription] = useState("");
  const [status, setStatus] = useState("");
  const [triggerTime, setTriggerTime] = useState("")
  const [isStatusDropdownOpen, setIsStatusDropdownOpen] = useState(false);
  const [isMessageDropdownOpen, setIsMessageDropdownOpen] = useState(false);
  const [isTimeDelayDropdownOpen, setIsTimeDelayDropdownOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [selectedTemplateMessageId, setSelectedTemplateMessageId] = useState("");
  const [selectedTemplateMessage, setSelectedTemplateMessage] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedStatusMessage, setSelectedStatusMessage] = useState("");
  const [timeDelay, setTimeDelay] = useState(0)
  const [timeDelayMessage,setTimeDelayMessage] = useState("")
  const [activate,setActivate] = useState(true);
  const [templates,setTemplates] = useState([]);
  const [workFlowAddingLoader,setWorkFlowAddingLoader] = useState(false);

  useEffect(() => {
      getTemplates();
    }, []);

  const statusOptions = [
    {
      id:1,
      message: "After guest moved to in-house"
    }
  ];

  const timeDelayOptions = [
    {
      id: 1,
      time: 0,
      message: "0 minutes"
    },
    {
      id: 2,
      time: 10,
      message: "10 minutes"
    },
    {
      id: 3,
      time: 30,
      message: "30 minutes"
    },
    {
      id: 4,
      time: 60,
      message: "1 Hour"
    },
    {
      id: 5,
      time: 120,
      message: "2 Hours"
    },
    {
      id: 6,
      time: 180,
      message: "3 Hours"
    },
  ]

  const toggleStatusDropdown = (e) => {
    e.stopPropagation();
    setIsStatusDropdownOpen(!isStatusDropdownOpen);
    if (!isStatusDropdownOpen) {
      setSearchTerm(""); // Reset search when opening
      setTimeout(() => {
        searchInputRef.current?.focus(); // Focus search input
      }, 0);
    }
  };

  const toggleTimeDelayDropdown = (e) => {
    e.stopPropagation();
    setIsTimeDelayDropdownOpen(!isTimeDelayDropdownOpen);
    if (!isStatusDropdownOpen) {
      setSearchTerm(""); // Reset search when opening
      setTimeout(() => {
        searchInputRef.current?.focus(); // Focus search input
      }, 0);
    }
  };

  const toggleMessageDropdown = (e) => {
    e.stopPropagation();
    setIsMessageDropdownOpen(!isMessageDropdownOpen);
    if (!isMessageDropdownOpen) {
      setSearchTerm(""); // Reset search when opening
      setTimeout(() => {
        searchInputRef.current?.focus(); // Focus search input
      }, 0);
    }
  }

  const handleAddWorkFlow = async (e) => {
    const propertyId = localStorage.getItem("selectedPropertyId")
    
    const workFlowData = {
      propertyId: propertyId === "" ? undefined : propertyId,
      messageTemplateId: selectedTemplateMessageId === "" ? undefined : selectedTemplateMessageId,
      trigger: status,
      name: flowName,
      description: description,
      timeDelay,
      flowStatus: activate
    }
    try{
      setWorkFlowAddingLoader(true)
      console.log(workFlowData)
      const response = await apiClient.post(
              `${baseUrl}/customFlow/${propertyId}`,
              workFlowData
            );
      if (response.ok) {
          const newToken = response.headers.get("Authorization");
          if (newToken) {
            localStorage.setItem("accessToken", newToken.split(" ")[1]); // Save the new token
          }
        }
        toast.success(response.data.message);
        onClose();
    } catch(error) {
      console.log(error.response)
      let errorMessage =
				error.response?.data?.message ||
				"Failed to add the guest. Please try again.";
      toast.error(errorMessage)
    } finally {
      setWorkFlowAddingLoader(false)
    }    
  }
  const getTemplates = async () => {
		try {
			const response = await apiClient.get(
				`${baseUrl}/messageTemplate/${selectedPropertyId}`
			);
			if (response.ok) {
				const newToken = response.headers.get("Authorization");
				if (newToken) {
					localStorage.setItem("accessToken", newToken.split(" ")[1]); // Save the new token
				}
			}
			setTemplates(response.data.result.reverse());
		} catch (error) {
			console.error("Error fetching data:", error);
		}
	};

  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-6 rounded-lg shadow-xl lg:w-[80vh] overflow-auto space-y-4">
        {/* Modal Header */}
        <div className="flex justify-between items-center">
          <h2 className="text-lg font-semibold">New Flow Modal</h2>
          <button onClick={onClose} className="text-gray-600 hover:text-gray-900">
            <AiOutlineClose size={24} />
          </button>
        </div>

        {/* Flow Name */}
        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">Flow Name</label>
          <input
            type="text"
            value={flowName}
            onChange={(e) => setFlowName(e.target.value)}
            className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm text-gray-700 
                       focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 placeholder:text-gray-400"
          />
        </div>

        {/* Describe Purpose */}
        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">Describe Purpose</label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className="w-full h-10 rounded-md border border-gray-300 px-3 py-2 text-sm text-gray-700 
                       focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 placeholder:text-gray-400"
          />
        </div>

        <div className="flex items-center justify-between space-x-6">
          {/* First Column - When to trigger? */}
          <div className="w-1/2">
            <label className="block text-[13px] font-medium mb-1 text-gray-700">
              When to trigger?
            </label>
            <div className="relative">
              <button
                type="button"
                onClick={toggleStatusDropdown}
                className="w-full flex items-center justify-between px-3 py-2 border border-gray-300 bg-white rounded-md text-sm hover:bg-gray-50"
              >
                <span className="flex items-center gap-2">
                  {status ? status : "Please Select Status"}
                </span>
                <svg
                  className={`w-4 h-4 text-gray-400 transition-transform duration-200 ${
                    isStatusDropdownOpen ? "rotate-180" : ""
                  }`}
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
                </svg>
              </button>

              {/* Dropdown */}
              {isStatusDropdownOpen && (
                <div
                  ref={dropdownRef}
                  className="absolute top-full left-0 mt-1 w-[250px] bg-white border border-gray-200 rounded-md shadow-lg z-50"
                >
                  <ul className="max-h-48 overflow-auto">
                    {statusOptions.map((option) => (
                      
                    <li
                      key={option.id}
                      onClick={(e) => {
                        setStatus(option.message)
                        setSelectedStatusMessage(option.message)
                        toggleStatusDropdown(e)
                      }}
                      className="px-3 py-2 cursor-pointer hover:bg-gray-100"
                    >
                      {option.message}
                    </li>
                  ))}
                </ul>
                </div>
              )}
            </div>
          </div>

          {/* Second Column - What time should this trigger? */}
          
            <div className="w-1/2">
            <label className="block text-[13px] font-medium text-gray-700">
              Delay Trigger To?
            </label>
            <div className="relative">
              <button
                type="button"
                onClick={toggleTimeDelayDropdown}
                className="w-full flex items-center justify-between px-3 py-2 border border-gray-300 bg-white rounded-md text-sm hover:bg-gray-50"
              >
                <span className="flex items-center gap-2">
                  {timeDelayMessage ? timeDelayMessage : "Please Select Delay"}
                </span>
                <svg
                  className={`w-4 h-4 text-gray-400 transition-transform duration-200 ${
                    isStatusDropdownOpen ? "rotate-180" : ""
                  }`}
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
                </svg>
              </button>

              {/* Dropdown */}
              {isTimeDelayDropdownOpen && (
                <div
                  ref={dropdownRef}
                  className="absolute top-full left-0 mt-1 w-[250px] bg-white border border-gray-200 rounded-md shadow-lg z-50"
                >
                  <ul className="max-h-48 overflow-auto">
                    {timeDelayOptions.map((option) => (
                      
                    <li
                      key={option.id}
                      onClick={(e) => {
                        setTimeDelay(option.time)
                        setTimeDelayMessage(option.message)
                        toggleTimeDelayDropdown(e)
                      }}
                      className="px-3 py-2 cursor-pointer hover:bg-gray-100"
                    >
                      {option.message}
                    </li>
                  ))}
                </ul>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Select Message Template */}
        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">Select Message Template</label>
          <div className="relative w-full">
            <button
              type="button"
              onClick={toggleMessageDropdown}
              className="w-full flex items-center justify-between px-3 py-2 border border-gray-300 bg-white rounded-md text-sm hover:bg-gray-50"
            >
              <span className="flex items-center gap-2">
                {selectedTemplate ? selectedTemplate : "Please Select a Template"}
              </span>
              <svg
                className={`w-4 h-4 text-gray-400 transition-transform duration-200 ${
                  isMessageDropdownOpen ? "rotate-180" : ""
                }`}
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
              </svg>
            </button>
            {isMessageDropdownOpen && (
              <div
                ref={dropdownRef}
                className="absolute top-full left-0 mt-1 w-full bg-white border border-gray-200 rounded-md shadow-lg z-50"
              >
                {/* Dropdown  Message Template */}
                <ul className="max-h-48 overflow-auto">
                    {templates.map((template) => (
                      
                    <li
                      key={template.id}
                      onClick={(e) => {
                        setSelectedTemplate(template.name)
                        setSelectedTemplateMessage(template.message)
                        setSelectedTemplateMessageId(template._id)
                        toggleMessageDropdown(e)
                      }}
                      className="px-3 py-2 cursor-pointer hover:bg-gray-100"
                    >
                      {template.name}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
        <div className="space-y-2">
          <textarea
            value={selectedTemplateMessage}
            placeholder="Template Message"
            readOnly
            className="w-full h-15 rounded-md border border-gray-300 px-3 py-2 text-sm text-gray-700 
                       focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 placeholder:text-gray-400"
          />
        </div>
        <div>
          <div className="flex flex-col lg:flex-row items-center justify-between">
            {/* Switch */}
            <div className="flex items-center mb-2 lg:mb-0">
              <Switch
                checked={activate}
                onChange={() => {
                  setActivate((prev) => {
                    const newValue = !prev;
                    return newValue;
                  });
                }}
                className={classNames(
                  activate ? "bg-indigo-600" : "bg-gray-200",
                  "relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2"
                )}
              >
                {/* <span className="sr-only">Use setting</span> */}
                <span
                  aria-hidden="true"
                  className={classNames(
                    activate ? "translate-x-5" : "translate-x-0",
                    "pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
                  )}
                />
              </Switch>
              <div className="justify-start">
                <div>
                  <label
                    htmlFor="toggle"
                    className="ml-2 text-[13px] font-medium text-[#111827]"
                  >
                    Flow Status
                  </label>
                </div>
              </div>
            </div>
            {/* Add WorkFlow Button */}
            <button
              onClick={handleAddWorkFlow}
              className="lg:ml-2 text-white font-semibold px-4 py-2 rounded-md text-[13px] focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-indigo-600"
            >
              {workFlowAddingLoader ? "Creating..." : "Create"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewFlowModal;
